import React from "react";
import { Link } from 'react-router-dom';

const Floor2 = ({ currentRoom, setHoveredRoom }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      clipRule="evenodd"
      viewBox="0 0 250 500"
    >
      {/* Base White */}
      <path
        fill="#fff"
        d="M28 54v120H13v198h95v-98h15v-29h59v18h23v33h26v-54h4V55h-6l-23-23h-29l-21 22h-3V37h-8v5h3v14h-6v2h-2v2h-19v-2h-2v-2h-6V42h3v-5h-15v-6h-5v13H48v10H28z"
      ></path>
      {/* CAT WALK */}
      <Link to='/explore/cat-walk'>
        <path
          id='cat-walk-path'
          fill="#565656"
          d="M113 89v101H81v24h4v4h14v-4h50v-7h4v-12h-4v-95h-1V89h-35z"
          className={`clickable ${currentRoom === 'cat-walk' ? 'current-room' : ''}`}
          onMouseEnter={() => setHoveredRoom('cat-walk')}
          onMouseLeave={() => setHoveredRoom(null)}
        ></path>
      </Link>
      {/* GROUP SEX ROOM */}
      <Link to='/explore/group-sex-room'>
        <path
          id='group-sex-room-path'
          fill="#565656"
          d="M157 59l22-23h25l23 23h4v103h-78v-42h-4v-20h3V59h5z"
          className={`clickable ${currentRoom === 'group-sex-room' ? 'current-room' : ''}`}
          onMouseEnter={() => setHoveredRoom('group-sex-room')}
          onMouseLeave={() => setHoveredRoom(null)}
        ></path>
      </Link>
      {/* LOCKER ROOM */}
      <Link to='/explore/locker-room'>
        <path
          id='locker-room-path'
          fill="#565656"
          d="M153 166v73h25v-4h28v3h8v4h12v-5h5v-71h-78z"
          className={`clickable ${currentRoom === 'locker-room' ? 'current-room' : ''}`}
          onMouseEnter={() => setHoveredRoom('locker-room')}
          onMouseLeave={() => setHoveredRoom(null)}
        ></path>
      </Link>
      {/* Int. Grey */}
      <g fill="#adadad">
        <path
          d="M52 58V48h41v11h15v41h5v21h-4v13H97v5h12v48H73v3h7v11h1v13H47v4h54v2h5v-2h43v22h-30v29h-14v-37h-5v3H85v-8H47v4h4v1h31v7h3v-1h15v60H17v-81h16v-12h-4v10H13v-41h16v17h4v-1h29v-3H32v-48h14v-5H32V58h20z"
          opacity="0.985"
        ></path>
        <path
          d="M113 60v29h35V60h-35zM186 242v18h24v33h18v-51h-42z"
          opacity="0.985"
        ></path>
      </g>
      {/* Base Outline */}
      <g
        fill="none"
        stroke="#000"
        strokeLinecap="square"
        strokeLinejoin="miter"
        strokeWidth="3"
      >
        <path
          d="M28 54v120H13v198h95v-98h15v-29h59v18h23v33h26v-54h4V55h-6l-23-23h-29l-21 22h-3V37h-7"
          opacity="0.985"
        ></path>
        <path d="M115 37h-14v-6h-5v13H48v10H29" opacity="0.985"></path>
      </g>
      {/* Int. Outline */}
      <g
        fill="none"
        stroke="#000"
        strokeLinejoin="miter"
        style={{pointerEvents: 'none'}}
      >
        <path
          strokeLinecap="square"
          d="M116 37v5h-3v14h6v2h2v2h-8v28h8v1h-8v11h-5V59H93V48H52v10H32v76h14v5H32v48h30v3H33v1h-4v-16h-1v17h5M14 178h14M14 181.667h14M14 185.333h14M14 189h14M14 215h15v-10h4v12H17v81h22v-32h1v32h20v-32h1v32h20v-32h1v32h18v-60H85v1h-3v-7h0-31v20H17M145 38v4h3v14h-6v2h-2v2h8v28h-8v1h8v11h4V59h5l22-23h25l23 23h4v103h-78v-42h-4 0v75h4v-29h78v71h-5v5h2v51h-18v-33h-24v-17M109 121h4v69h0-32v11h-1v-11h-7v-3h36v-48H97v-5h12v-13z"
          opacity="0.985"
        ></path>
        <path
          strokeLinecap="square"
          d="M47 214v4h38v-4H47zM47 227v4h38v-4H47zM84 218v9M80.667 218v9M77.333 218v9M74 218v9M70.667 218v9M67.333 217.989V227M64 223v4"
          opacity="0.985"
        ></path>
        <path
          strokeLinecap="butt"
          d="M65.695 217.991l-2.005 3.107.977 1.529-2.966-.753.977 1.528h0l-2.738 3.828"
        ></path>
        <path
          strokeLinecap="square"
          d="M85 231v4h15v-3h5v139"
          opacity="0.985"
        ></path>
        <path
          strokeLinecap="square"
          d="M105 269h14v-29h30v2h65v-4h-8v-3h-28v4h-25v-32h-4v7H99v4h2v2h5v-2h43v22M196 242v18M200 242v18M204 242v18M208 242v18M210 269.667h18M210 266h18M210 273.333h18M210 277h18M210 280.667h18M210 284.333h18M210 288h18M105 240h14M105 244h14M105 248h14M105 252h14M105 256h14M105 260h14M105 264h14M149 129h-19v60h19"
          opacity="0.985"
        ></path>
        <path
          strokeLinecap="square"
          d="M149 129h-19v60h19M130 133h19M130 136.714h19M130 140.429h19M130 144.143h19M130 147.857h19M130 151.571h19M130 155.286h19M130 159h19M130 162.714h19M130 166.429h19M130 170.143h19M130 173.857h19M130 177.571h19M130 181.286h19M130 185h19"
          opacity="0.985"
        ></path>
        <path
          strokeLinecap="butt"
          d="M148.809 152.008l-6.492 6.349 1.509 4.192-6.694-3.418 1.509 4.191h0L130 171"
        ></path>
        <path d="M121 60l5 7M121 88.729l5 7M140 60l-5 7M140 88.729l-5 7M153 120l8-12M153 207l9-6M106 220l7 6M29 205l-8-6M226 242l-6 8M99 218l-6 7"></path>
      </g>
      {/* Icons */}
      <g>
        <path
          fill="#fff"
          stroke="#8f1442"
          strokeWidth="0.5"
          d="M212.701 223.979h14.216v9.351h-14.216v-9.351z"
          style={{pointerEvents: 'none'}}
        ></path>
        <path
          fill="#8f1442"
          d="M219.278 223.941h7.628v9.391h-7.628v-9.391z"
          style={{pointerEvents: 'none'}}
        ></path>
        <g fill="#8f1442" style={{pointerEvents: 'none'}}>
          <path d="M215.715 226.975c-.066-.133-.203-.181-.275-.133l-.524.351c-.072.049-.038.242.01.314l1.12 1.795c.05.072.111.096.183.047l.346-.212c.3-.256.245-.479.078-.769l-.938-1.393zm-1.034-1.183a.528.528 0 110 1.056.528.528 0 010-1.056z"></path>
          <path d="M215.511 226.814l.951-.207a.276.276 0 01.211.041l.783.604c.129.111.252.251.167.376-.054.081-.24.035-.338-.024l-.821-.436-.837.182a.274.274 0 01-.116-.536zm1.479 2.308l.312.434s.819.057 1.112.074c.225.013.359.097.359.242s-.113.227-.437.253c-.272.022-1.204.079-1.204.079h-.003a.367.367 0 01-.298-.168l-.304-.45s.432-.292.463-.464zm-2.049.313l.955-.655a.33.33 0 01.372.543l-.729.5.433 1.069c.163.392.12.56.008.607-.112.048-.263.026-.495-.4l-.659-1.259a.33.33 0 01.115-.405z"></path>
          <path d="M213.803 228.21l.672-.057.385-.872a.275.275 0 01.363-.138c.138.061.199.223.138.362l-.418.936c-.04.088-.128.173-.224.185 0 0-.667-.015-.849-.025-.191-.01-.405-.046-.41-.177-.007-.188.17-.202.343-.214z"></path>
        </g>
        <path
          fill="#fff"
          d="M225.055 229.486a1.842 1.842 0 01-3.683 0c0-1.382 1.688-2.533 1.688-3.837.383.192.997.869.997 1.765 0 .383-.077.767-.077.767.461-.153.461-.69.461-.69s.614.844.614 1.995z"
          style={{pointerEvents: 'none'}}
        ></path>
        <path
          fill="#8f1442"
          d="M223.2 227.884a.039.039 0 00-.064.029c0 .577-.299 1.004-.564 1.38-.223.318-.433.619-.433.96 0 .592.482 1.074 1.074 1.074.592 0 1.074-.482 1.074-1.074 0-1.421-1.076-2.36-1.087-2.369z"
        ></path>
        <path
          fill="#fff"
          d="M223.283 229.041a.039.039 0 00-.07.023c0 .348-.184.597-.361.838-.17.23-.33.447-.33.735a.692.692 0 001.382 0c0-.482-.209-1.019-.621-1.596z"
        ></path>
        <path
          fill="#1f212b"
          d="M223.957 229.025a.04.04 0 01-.035-.022 1.782 1.782 0 00-.037-.076.038.038 0 01.018-.051.037.037 0 01.051.017c.013.025.026.051.038.078a.038.038 0 01-.018.051.05.05 0 01-.017.003zm.175.461a.038.038 0 01-.037-.028 3.1 3.1 0 00-.106-.303.038.038 0 01.021-.05.038.038 0 01.05.021c.041.101.078.205.109.31a.039.039 0 01-.027.048.036.036 0 01-.01.002z"
        ></path>
        <path
          fill="#1f212b"
          d="M223.213 231.327a1.075 1.075 0 01-1.074-1.074c0-.341.21-.642.433-.96.265-.376.564-.803.564-1.38 0-.015.009-.029.023-.035a.04.04 0 01.041.005c.015.013.368.32.671.855a.039.039 0 01-.014.052.04.04 0 01-.053-.014 3.57 3.57 0 00-.593-.777c-.028.557-.318.971-.576 1.338-.225.321-.419.599-.419.916a.998.998 0 001.995 0c0-.112-.008-.223-.022-.341a.037.037 0 01.033-.042.038.038 0 01.043.033 2.8 2.8 0 01.022.35c0 .592-.482 1.074-1.074 1.074z"
        ></path>
        <path
          fill="#1f212b"
          d="M223.719 229.946a.037.037 0 01-.036-.025l-.03-.075a.039.039 0 01.02-.051.039.039 0 01.05.021c.011.026.022.052.031.078a.037.037 0 01-.022.049.03.03 0 01-.013.003zm-.1-.23a.04.04 0 01-.035-.022 3.106 3.106 0 00-.077-.152.038.038 0 11.068-.036c.028.051.054.103.079.155a.038.038 0 01-.018.051.035.035 0 01-.017.004z"
        ></path>
        <path
          fill="#1f212b"
          d="M223.213 231.327a.692.692 0 01-.691-.69c0-.288.16-.505.33-.735.177-.241.361-.49.361-.838a.039.039 0 01.07-.023c.049.07.1.146.155.232a.039.039 0 01-.012.053.038.038 0 01-.053-.012 4.074 4.074 0 00-.089-.136c-.034.314-.205.545-.37.77-.162.219-.315.427-.315.689a.615.615 0 001.228 0c0-.084-.007-.173-.021-.263a.039.039 0 01.032-.044.04.04 0 01.044.032c.014.094.022.187.022.275 0 .38-.31.69-.691.69z"
        ></path>
        <path
          fill="none"
          stroke="#8f1442"
          strokeWidth="0.75"
          d="M220 233v7M218 238l2 2 2-2"
          style={{pointerEvents: 'none'}}
        ></path>
        <path
          fill="#fff"
          stroke="#8f1442"
          strokeWidth="0.5"
          d="M41 193.037h14.216v9.352H41v-9.352z"
        ></path>
        <path fill="#8f1442" d="M47.577 193h7.628v9.39h-7.628V193z"></path>
        <g fill="#8f1442">
          <path d="M44.014 196.034c-.066-.134-.203-.182-.275-.134l-.524.352c-.072.048-.038.242.01.314l1.12 1.795c.05.072.11.096.183.047l.346-.212c.3-.256.245-.48.078-.769l-.938-1.393zm-1.034-1.184a.528.528 0 11-.001 1.057.528.528 0 010-1.057z"></path>
          <path d="M43.81 195.872l.951-.207c.073-.015.15 0 .211.041l.783.605c.129.111.252.25.167.375-.054.081-.24.035-.337-.024l-.822-.436-.836.182a.273.273 0 01-.326-.209.275.275 0 01.209-.327zm1.479 2.308l.312.434s.82.057 1.113.074c.224.014.358.097.358.243 0 .145-.113.227-.436.253-.273.021-1.205.078-1.205.078h-.003a.364.364 0 01-.297-.168l-.305-.45s.432-.292.463-.464zm-2.049.313l.955-.654a.33.33 0 01.372.543l-.73.499.434 1.07c.163.392.12.56.008.607-.112.047-.262.026-.495-.401l-.659-1.258a.33.33 0 01.115-.406z"></path>
          <path d="M42.102 197.268l.673-.057.385-.872a.274.274 0 11.5.224l-.418.937c-.04.088-.128.173-.223.184 0 0-.667-.014-.85-.024-.19-.011-.405-.046-.41-.177-.007-.188.17-.202.343-.215z"></path>
        </g>
        <path
          fill="#fff"
          d="M53.354 198.544a1.842 1.842 0 11-3.683 0c0-1.381 1.688-2.532 1.688-3.836.383.191.997.869.997 1.764 0 .384-.076.768-.076.768.46-.154.46-.691.46-.691s.614.844.614 1.995z"
        ></path>
        <path
          fill="#8f1442"
          d="M51.499 196.942a.038.038 0 00-.041-.006.04.04 0 00-.023.035c0 .577-.299 1.004-.563 1.381-.223.318-.434.618-.434.959 0 .593.482 1.075 1.074 1.075.593 0 1.075-.482 1.075-1.075 0-1.42-1.077-2.36-1.088-2.369z"
        ></path>
        <path
          fill="#fff"
          d="M51.582 198.1c-.01-.014-.027-.019-.043-.014a.037.037 0 00-.027.036c0 .349-.184.598-.361.839-.17.23-.33.447-.33.734a.692.692 0 001.382 0c0-.482-.21-1.018-.621-1.595z"
        ></path>
        <path
          fill="#1f212b"
          d="M52.256 198.084a.038.038 0 01-.034-.022 2.987 2.987 0 00-.037-.076.039.039 0 01.017-.052.04.04 0 01.051.017l.038.078a.038.038 0 01-.018.051.032.032 0 01-.017.004zm.175.46a.039.039 0 01-.037-.027 3.08 3.08 0 00-.106-.304.038.038 0 01.02-.05.039.039 0 01.05.021c.042.101.079.206.11.311a.039.039 0 01-.026.048l-.011.001z"
        ></path>
        <path
          fill="#1f212b"
          d="M51.512 200.386a1.076 1.076 0 01-1.074-1.075c0-.341.21-.641.434-.959.264-.377.563-.804.563-1.381a.04.04 0 01.023-.035.038.038 0 01.04.006c.016.013.37.32.672.854a.04.04 0 01-.014.053.04.04 0 01-.053-.015 3.6 3.6 0 00-.593-.777c-.027.558-.318.972-.575 1.339-.226.321-.42.598-.42.915a1 1 0 00.997.998 1 1 0 00.998-.998 2.73 2.73 0 00-.022-.34.039.039 0 01.033-.043.038.038 0 01.043.033c.015.121.023.236.023.35 0 .593-.482 1.075-1.075 1.075z"
        ></path>
        <path
          fill="#1f212b"
          d="M52.018 199.005a.039.039 0 01-.036-.025 2.662 2.662 0 00-.03-.076.038.038 0 11.07-.029l.032.078a.038.038 0 01-.023.049.033.033 0 01-.013.003zm-.1-.231a.039.039 0 01-.034-.021 3.506 3.506 0 00-.078-.152.038.038 0 01.016-.052.039.039 0 01.052.015c.028.052.054.104.079.155a.038.038 0 01-.018.051.033.033 0 01-.017.004z"
        ></path>
        <path
          fill="#1f212b"
          d="M51.512 200.386c-.38 0-.69-.31-.69-.691 0-.287.16-.504.329-.734.177-.241.361-.49.361-.839 0-.017.011-.031.027-.036a.037.037 0 01.043.014c.05.069.1.145.155.232a.039.039 0 01-.012.053.039.039 0 01-.053-.012 5.897 5.897 0 00-.089-.137c-.034.314-.205.546-.37.771-.162.219-.315.426-.315.688a.614.614 0 001.228 0c0-.084-.007-.172-.021-.263a.038.038 0 01.032-.043.038.038 0 01.044.032c.014.094.022.186.022.274 0 .381-.31.691-.69.691z"
        ></path>
        <path
          fill="none"
          stroke="#8f1442"
          strokeLinecap="butt"
          strokeWidth="0.75"
          d="M41 198h-9"
        ></path>
        <path
          fill="none"
          stroke="#8f1442"
          strokeWidth="0.75"
          d="M34 196l-2 2 2 2"
        ></path>
        <g
          fill="none"
          stroke="#8f1442"
          strokeLinejoin="miter"
          strokeWidth="0.75"
        >
          <path d="M112 262v-19M115 246l-3-3-3 3"></path>
        </g>
        <g
          fill="none"
          stroke="#8f1442"
          strokeLinejoin="miter"
          strokeWidth="0.75"
        >
          <path d="M85 222.5H67M70 219.5l-3 3 3 3"></path>
        </g>
        <g
          fill="none"
          stroke="#8f1442"
          strokeLinejoin="miter"
          strokeWidth="0.75"
          style={{pointerEvents: 'none'}}
        >
          <path d="M139.5 190v-19M142.5 174l-3-3-3 3"></path>
        </g>
        <g
          fill="none"
          stroke="#8f1442"
          strokeLinejoin="miter"
          strokeWidth="0.75"
        >
          <path d="M21 191v-12M24 182l-3-3-3 3"></path>
        </g>
        <g
          fill="none"
          stroke="#8f1442"
          strokeLinejoin="miter"
          strokeWidth="0.75"
        >
          <path d="M209 251h-15M197 248l-3 3 3 3"></path>
        </g>
        <g
          fill="none"
          stroke="#8f1442"
          strokeLinejoin="miter"
          strokeWidth="0.75"
        >
          <path d="M219 265v25M216 287l3 3 3-3"></path>
        </g>
        <g
          fill="none"
          stroke="#8f1442"
          strokeLinejoin="miter"
          strokeWidth="0.75"
          style={{pointerEvents: 'none'}}
        >
          <path d="M139.5 128v19M136.5 144l3 3 3-3"></path>
        </g>
        {/* LOCKERS - UPPER ROW */}
        <g fill="black" style={{pointerEvents: 'none'}}>
          <path d="M171.99 167h-4.752a.432.432 0 00-.432.432v17.282c0 .238.193.432.432.432h4.752a.432.432 0 00.432-.432v-17.282a.432.432 0 00-.432-.432zm-1.296 16.417h-2.16a.432.432 0 010-.864h2.16a.431.431 0 110 .864zm0-1.296h-2.16a.432.432 0 010-.864h2.16a.431.431 0 110 .864zm.432-5.184a.431.431 0 11-.864 0v-1.728a.432.432 0 01.864 0v1.728zm-.432-5.617h-2.16a.432.432 0 010-.864h2.16a.431.431 0 110 .864zm0-1.296h-2.16a.432.432 0 010-.864h2.16a.431.431 0 110 .864zM159.029 167h-4.752a.432.432 0 00-.432.432v17.282c0 .238.193.432.432.432h4.752a.432.432 0 00.432-.432v-17.282a.432.432 0 00-.432-.432zm-3.456 2.16h2.16a.431.431 0 110 .864h-2.16a.431.431 0 110-.864zm2.16 14.257h-2.16a.431.431 0 110-.864h2.16a.431.431 0 110 .864zm0-1.296h-2.16a.431.431 0 110-.864h2.16a.431.431 0 110 .864zm.432-5.184a.431.431 0 11-.864 0v-1.728a.432.432 0 01.864 0v1.728zm-.432-5.617h-2.16a.431.431 0 110-.864h2.16a.431.431 0 110 .864zm7.777-4.32h-4.753a.433.433 0 00-.432.432v17.282c0 .238.194.432.432.432h4.753a.433.433 0 00.432-.432v-17.282a.433.433 0 00-.432-.432zm-3.457 2.16h2.161a.432.432 0 010 .864h-2.161a.432.432 0 010-.864zm2.161 14.257h-2.161a.432.432 0 010-.864h2.161a.432.432 0 010 .864zm0-1.296h-2.161a.432.432 0 010-.864h2.161a.432.432 0 010 .864zm.432-5.184a.432.432 0 01-.864 0v-1.728a.431.431 0 11.864 0v1.728zm-.432-5.617h-2.161a.432.432 0 010-.864h2.161a.432.432 0 010 .864zM191.183 167h-4.753a.433.433 0 00-.432.432v17.282c0 .238.194.432.432.432h4.753a.433.433 0 00.432-.432v-17.282a.433.433 0 00-.432-.432zm-1.296 16.417h-2.16a.431.431 0 110-.864h2.16a.432.432 0 010 .864zm0-1.296h-2.16a.431.431 0 110-.864h2.16a.432.432 0 010 .864zm.432-5.184a.432.432 0 01-.864 0v-1.728a.431.431 0 11.864 0v1.728zm-.432-5.617h-2.16a.431.431 0 110-.864h2.16a.432.432 0 010 .864zm0-1.296h-2.16a.431.431 0 110-.864h2.16a.432.432 0 010 .864zM178.222 167h-4.753a.433.433 0 00-.432.432v17.282c0 .238.194.432.432.432h4.753a.433.433 0 00.432-.432v-17.282a.433.433 0 00-.432-.432zm-3.457 2.16h2.161a.432.432 0 010 .864h-2.161a.432.432 0 010-.864zm2.161 14.257h-2.161a.432.432 0 010-.864h2.161a.432.432 0 010 .864zm0-1.296h-2.161a.432.432 0 010-.864h2.161a.432.432 0 010 .864zm.432-5.184a.432.432 0 01-.864 0v-1.728a.431.431 0 11.864 0v1.728zm-.432-5.617h-2.161a.432.432 0 010-.864h2.161a.432.432 0 010 .864zm7.776-4.32h-4.752a.432.432 0 00-.432.432v17.282c0 .238.193.432.432.432h4.752a.432.432 0 00.432-.432v-17.282a.432.432 0 00-.432-.432zm-3.456 2.16h2.16a.431.431 0 110 .864h-2.16a.432.432 0 010-.864zm2.16 14.257h-2.16a.432.432 0 010-.864h2.16a.431.431 0 110 .864zm0-1.296h-2.16a.432.432 0 010-.864h2.16a.431.431 0 110 .864zm.432-5.184a.431.431 0 11-.864 0v-1.728a.432.432 0 01.864 0v1.728zm-.432-5.617h-2.16a.432.432 0 010-.864h2.16a.431.431 0 110 .864zM210.375 167h-4.752a.433.433 0 00-.432.432v17.282c0 .238.194.432.432.432h4.752a.432.432 0 00.432-.432v-17.282a.432.432 0 00-.432-.432zm-1.296 16.417h-2.16a.432.432 0 010-.864h2.16a.431.431 0 110 .864zm0-1.296h-2.16a.432.432 0 010-.864h2.16a.431.431 0 110 .864zm.432-5.184a.431.431 0 11-.864 0v-1.728a.432.432 0 01.864 0v1.728zm-.432-5.617h-2.16a.432.432 0 010-.864h2.16a.431.431 0 110 .864zm0-1.296h-2.16a.432.432 0 010-.864h2.16a.431.431 0 110 .864zM197.414 167h-4.752a.432.432 0 00-.432.432v17.282c0 .238.193.432.432.432h4.752a.432.432 0 00.432-.432v-17.282a.432.432 0 00-.432-.432zm-3.456 2.16h2.16a.431.431 0 110 .864h-2.16a.432.432 0 010-.864zm2.16 14.257h-2.16a.432.432 0 010-.864h2.16a.431.431 0 110 .864zm0-1.296h-2.16a.432.432 0 010-.864h2.16a.431.431 0 110 .864zm.432-5.184a.431.431 0 11-.864 0v-1.728a.432.432 0 01.864 0v1.728zm-.432-5.617h-2.16a.432.432 0 010-.864h2.16a.431.431 0 110 .864zm7.777-4.32h-4.753a.433.433 0 00-.432.432v17.282c0 .238.194.432.432.432h4.753a.433.433 0 00.432-.432v-17.282a.433.433 0 00-.432-.432zm-3.456 2.16h2.16a.432.432 0 010 .864h-2.16a.431.431 0 110-.864zm2.16 14.257h-2.16a.431.431 0 110-.864h2.16a.432.432 0 010 .864zm0-1.296h-2.16a.431.431 0 110-.864h2.16a.432.432 0 010 .864zm.432-5.184a.432.432 0 01-.864 0v-1.728a.431.431 0 11.864 0v1.728zm-.432-5.617h-2.16a.431.431 0 110-.864h2.16a.432.432 0 010 .864zM229.568 167h-4.752a.432.432 0 00-.432.432v17.282c0 .238.193.432.432.432h4.752a.433.433 0 00.432-.432v-17.282a.433.433 0 00-.432-.432zm-1.296 16.417h-2.16a.431.431 0 110-.864h2.16a.432.432 0 010 .864zm0-1.296h-2.16a.431.431 0 110-.864h2.16a.432.432 0 010 .864zm.432-5.184a.432.432 0 01-.864 0v-1.728a.431.431 0 11.864 0v1.728zm-.432-5.617h-2.16a.431.431 0 110-.864h2.16a.432.432 0 010 .864zm0-1.296h-2.16a.431.431 0 110-.864h2.16a.432.432 0 010 .864zM216.607 167h-4.753a.433.433 0 00-.432.432v17.282c0 .238.194.432.432.432h4.753a.433.433 0 00.432-.432v-17.282a.433.433 0 00-.432-.432zm-3.456 2.16h2.16a.432.432 0 010 .864h-2.16a.432.432 0 110-.864zm2.16 14.257h-2.16a.432.432 0 110-.864h2.16a.432.432 0 010 .864zm0-1.296h-2.16a.432.432 0 110-.864h2.16a.432.432 0 010 .864zm.432-5.184a.432.432 0 01-.864 0v-1.728a.431.431 0 11.864 0v1.728zm-.432-5.617h-2.16a.432.432 0 110-.864h2.16a.432.432 0 010 .864zm7.776-4.32h-4.752a.433.433 0 00-.432.432v17.282c0 .238.194.432.432.432h4.752a.432.432 0 00.432-.432v-17.282a.432.432 0 00-.432-.432zm-3.456 2.16h2.16a.431.431 0 110 .864h-2.16a.432.432 0 010-.864zm2.16 14.257h-2.16a.432.432 0 010-.864h2.16a.431.431 0 110 .864zm0-1.296h-2.16a.432.432 0 010-.864h2.16a.431.431 0 110 .864zm.432-5.184a.431.431 0 11-.864 0v-1.728a.432.432 0 01.864 0v1.728zm-.432-5.617h-2.16a.432.432 0 010-.864h2.16a.431.431 0 110 .864z"></path>
        </g>
        {/* LOCKERS - LOWER ROW */}
        <path
          fill="black"
          d="M189.568 194.85h-4.754a.433.433 0 00-.432.432v17.286c0 .238.194.432.432.432h4.754a.433.433 0 00.432-.432v-17.286a.433.433 0 00-.432-.432zm-1.297 16.421h-2.16a.431.431 0 110-.864h2.16a.432.432 0 110 .864zm0-1.296h-2.16a.431.431 0 110-.864h2.16a.432.432 0 110 .864zm.433-5.186a.432.432 0 01-.865 0v-1.728a.432.432 0 01.865 0v1.728zm-.433-5.618h-2.16a.431.431 0 110-.864h2.16a.432.432 0 110 .864zm0-1.296h-2.16a.431.431 0 110-.864h2.16a.432.432 0 110 .864zm-11.667-3.025h-4.754a.432.432 0 00-.432.432v17.286c0 .238.193.432.432.432h4.754a.433.433 0 00.432-.432v-17.286a.433.433 0 00-.432-.432zm-3.458 2.161h2.161a.431.431 0 110 .864h-2.161a.432.432 0 010-.864zm2.161 14.26h-2.161a.432.432 0 010-.864h2.161a.431.431 0 110 .864zm0-1.296h-2.161a.432.432 0 010-.864h2.161a.431.431 0 110 .864zm.432-5.186a.431.431 0 11-.864 0v-1.728a.432.432 0 01.864 0v1.728zm-.432-5.618h-2.161a.432.432 0 010-.864h2.161a.431.431 0 110 .864zm7.779-4.321h-4.754a.433.433 0 00-.432.432v17.286c0 .238.194.432.432.432h4.754a.433.433 0 00.432-.432v-17.286a.433.433 0 00-.432-.432zm-3.457 2.161h2.16a.431.431 0 110 .864h-2.16a.432.432 0 110-.864zm2.16 14.26h-2.16a.432.432 0 110-.864h2.16a.431.431 0 110 .864zm0-1.296h-2.16a.432.432 0 110-.864h2.16a.431.431 0 110 .864zm.432-5.186a.431.431 0 11-.864 0v-1.728a.432.432 0 01.864 0v1.728zm-.432-5.618h-2.16a.432.432 0 110-.864h2.16a.431.431 0 110 .864zM209.15 194.85h-4.754a.433.433 0 00-.432.432v17.286c0 .238.194.432.432.432h4.754a.432.432 0 00.432-.432v-17.286a.432.432 0 00-.432-.432zm-1.296 16.421h-2.161a.431.431 0 110-.864h2.161a.432.432 0 010 .864zm0-1.296h-2.161a.431.431 0 110-.864h2.161a.432.432 0 010 .864zm.432-5.186a.432.432 0 01-.865 0v-1.728a.432.432 0 01.865 0v1.728zm-.432-5.618h-2.161a.431.431 0 110-.864h2.161a.432.432 0 010 .864zm0-1.296h-2.161a.431.431 0 110-.864h2.161a.432.432 0 010 .864zm-11.668-3.025h-4.754a.433.433 0 00-.432.432v17.286c0 .238.194.432.432.432h4.754a.433.433 0 00.432-.432v-17.286a.433.433 0 00-.432-.432zm-3.457 2.161h2.16a.431.431 0 110 .864h-2.16a.432.432 0 110-.864zm2.16 14.26h-2.16a.432.432 0 110-.864h2.16a.431.431 0 110 .864zm0-1.296h-2.16a.432.432 0 110-.864h2.16a.431.431 0 110 .864zm.432-5.186a.431.431 0 11-.864 0v-1.728a.432.432 0 01.864 0v1.728zm-.432-5.618h-2.16a.432.432 0 110-.864h2.16a.431.431 0 110 .864zm7.779-4.321h-4.754a.433.433 0 00-.432.432v17.286c0 .238.194.432.432.432h4.754a.433.433 0 00.432-.432v-17.286a.433.433 0 00-.432-.432zm-3.457 2.161h2.16a.432.432 0 110 .864h-2.16a.431.431 0 110-.864zm2.16 14.26h-2.16a.431.431 0 110-.864h2.16a.432.432 0 110 .864zm0-1.296h-2.16a.431.431 0 110-.864h2.16a.432.432 0 110 .864zm.433-5.186a.432.432 0 01-.865 0v-1.728a.432.432 0 01.865 0v1.728zm-.433-5.618h-2.16a.431.431 0 110-.864h2.16a.432.432 0 110 .864z"
          style={{pointerEvents: 'none'}}
        ></path>
        <path
          fill="#ecebec"
          d="M172.43 329.097c.148.148.39.177.554.341.075.075.013.275.149.32.016.005.411-.444.512-.512-.301-.301-.878-.486-1.215-.149z"
        ></path>
      </g>
      {/* Floor 2 Add On Dotted */}
      <path
        fill="none"
        stroke="yellow"
        strokeDasharray="4"
        strokeLinejoin="miter"
        strokeWidth="2"
        d="M234 242h6v227H40.5h0l-5-7.5s-12.5 5-15 2.5 5-12.5 5-12.5l-7.5-5v-75"
      ></path>
    </svg>
  );
}

export default Floor2;